<template>
  <div class="main">
    <el-container
      v-if="!$store.state.isFalse"
      class="main"
    >
      <el-aside style="background-color: #212A39">
        <div
          class="main-logo"
          style="background-color: #fff;cursor: pointer"
          @click="goIndex"
        >
          <img
            style="width:138px;height: 30px;"
            src="../assets/13.svg"
            alt="example"
          />
        </div>
        <el-menu
          class="el-menu-vertical-demo"
          :default-active="activeMenuLast"
          style="margin-top:60px;height:calc(100% - 60px)"
          unique-opened
          router
          :collapse-transition="false"
          v-show="mainSubNav"
          @open="subMeunOpen"
        >
          <template v-for="item in dataSubMenu">
            <el-submenu
              :index="item.powerUrl"
              :key="item.id"
              v-if="item.children"
              style="margin-top:10px"
            >
              <template slot="title">
                <i :class="item.powerIcon"></i>
                <span>{{ item.powerName }}</span>
              </template>
              <template v-for="menu in item.children">
                <el-menu-item
                  @click="powerName(menu)"
                  :index="menu.powerUrl"
                  :key="menu.id"
                >
                  <span slot="title">{{menu.powerName}}</span>
                </el-menu-item>
              </template>
            </el-submenu>
          </template>
          <template v-for="item in dataSubMenu">
            <el-menu-item
              v-if="!item.children"
              :index="item.powerUrl"
              :key="item.id"
              style="margin-top:10px"
            >
              <i :class="item.powerIcon"></i>
              <span slot="title">{{item.powerName}}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header>
          <div class="main-nav">
            <el-menu
              :default-active="activeMenu"
              class="el-menu-demo"
              mode="horizontal"
              @select="handleSelect"
              text-color="#4E555B"
              active-text-color="#276CFF"
            >
              <el-menu-item
                v-for="submenu in dataMenu"
                :index="submenu.powerUrl"
                :indexPath="submenu.powerUrl"
                :key="submenu.id"
                class="i-color"
              >
                <span>{{ submenu.powerName}}</span>
              </el-menu-item>
              <div
                id="more-menu"
                style="position: absolute;right: 0;background-color:#fff;height:60px;"
                v-show="screenWidth<1367"
              >
                <el-menu
                  style="transform: translate(0%, 33%);"
                  class="el-menu-demo"
                  mode="horizontal"
                  @select="handleSelect"
                  text-color="#4E555B"
                  active-text-color="#276CFF"
                  v-if="moreList.length > 0"
                >
                  <el-submenu index="2">
                    <template slot="title">
                      <span>更多</span>
                    </template>
                    <el-menu-item
                      v-for="(item,index) in moreList"
                      :index="item.powerUrl"
                      :key="index"
                    >{{item.powerName}}
                    </el-menu-item>
                  </el-submenu>
                </el-menu>
              </div>
            </el-menu>
          </div>
          <div
            class="main-logout"
            style="padding-right:20px;"
          >
            <div class="main-news">
              <el-dropdown
                trigger="hover"
                @command="handleinforomCommand"
              >
                <div
                  class="inform_icon"
                  style="cursor:pointer;"
                >
                  <el-badge
                    :value="(informNum.notice || 0) + (informNum.inform || 0) + (informNum.backlog || 0)"
                    :hidden="!((informNum.notice || 0) + (informNum.inform || 0) + (informNum.backlog || 0))"
                    :max="99"
                  >
                    <i class="iconfont icon-daohanglan-xiaoxi"></i>
                  </el-badge>
                </div>
                <el-dropdown-menu
                  slot="dropdown"
                  style="width: 150px"
                  class="inform_meun_sub"
                >
                  <el-dropdown-item
                    style="padding:5px 10px;"
                    command="notice"
                  >
                    <el-badge
                      :hidden="!informNum.notice"
                      :value="informNum.notice"
                      :max="99"
                    >公告
                    </el-badge>
                  </el-dropdown-item>
                  <el-dropdown-item
                    style="padding:5px 10px;"
                    command="inform"
                  >
                    <el-badge
                      :hidden="!informNum.inform"
                      :value="informNum.inform"
                      :max="99"
                    >我的通知
                    </el-badge>
                  </el-dropdown-item>
                  <el-dropdown-item
                    style="padding:5px 10px;"
                    command="backlog"
                  >
                    <el-badge
                      :hidden="!informNum.backlog"
                      :value="informNum.backlog"
                      :max="99"
                    >我的待办
                    </el-badge>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="head-portrait">
              <img
                style="width:100%;border-radius: 50%;"
                src="../assets/img/headPortrait.jpg"
              />
            </div>
            <div class="main-user">
              <el-dropdown
                trigger="click"
                @command="handleCommand"
              >
                <span
                  class="el-dropdown-link"
                  style="cursor: pointer"
                >
                  {{userName}}
                  <i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
                <el-dropdown-menu
                  slot="dropdown"
                  style="width: 150px;"
                  class="inform_meun_sub"
                >
                  <el-dropdown-item
                    style="padding:5px 10px;font-size: 14px;"
                    command="accountDetail"
                  >账号详情
                  </el-dropdown-item>
                  <el-dropdown-item
                    style="padding:5px 10px;font-size: 14px;"
                    command="updataPsd"
                  >修改密码
                  </el-dropdown-item>
                  <el-dropdown-item
                    style="padding:5px 10px;font-size: 14px;"
                    command="logOut"
                  >退出登录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-header>
        <el-main :style="{minHeight: tableHeight+'px'}">
          <Bread-crumb></Bread-crumb>
          <div style="margin-top: -4px;min-width:1100px;">
            <router-view></router-view>
          </div>
        </el-main>
      </el-container>
    </el-container>
    <div
      class="main"
      v-else
    >
      <fails404></fails404>
    </div>
    <v-base-dialog
      :title="`退出登录`"
      :dialogVisible.sync="loginDialogVisible"
      @successEv="loginOut"
    >
      <span style="padding:0 0 30px 26px;">确认是否退出当前账号。</span>
    </v-base-dialog>
    <v-base-dialog
      :title="`修改密码`"
      :dialogVisible.sync="upsdDialogVisible"
      @successEv="updataPsd"
      :succlosedialog="false"
      @cancelEv="clearFrom"
      @closedialogVisibale="clearFrom"
    >
      <template>
        <el-form
          :model="updataPsdForm"
          :rules="updataRules"
          v-loading="loading"
          ref="updataPsdForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="当前账号："
            prop="user"
          >
            <el-input
              v-model="userInfo.username"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="当前密码："
            prop="psd"
          >
            <el-input
              v-model="updataPsdForm.psd"
              type="password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item
            label="新密码："
            prop="newpsd"
          >
            <el-input
              type="password"
              v-model="updataPsdForm.newpsd"
              show-password
              auto-complete="new-password"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="确认新密码："
            prop="againNewpsd"
          >
            <el-input
              type="password"
              v-model="updataPsdForm.againNewpsd"
              show-password
              auto-complete="new-password"
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </v-base-dialog>
    <v-base-dialog
      :title="`账号详情`"
      :suc-txt="`提 交`"
      :dialogVisible.sync="actdDialogVisible"
      @successEv="getAccountInfo"
      :width="`600px`"
    >
      <template>
        <el-form
          :model="accountForm"
          label-width="80px"
          disabled
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="账号：">
                <el-input v-model="accountForm.staffName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="员工姓名：">
                <el-input v-model="accountForm.staffCnName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="密码：">
                <el-input
                  v-model="accountForm.password"
                  type="password"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码：">
                <el-input v-model="accountForm.staffMobilePhone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="邮箱：">
                <el-input v-model="accountForm.staffEmail"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="角色：">
                <el-input v-model="accountForm.roleName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属部门：">
                <el-input v-model="accountForm.orgName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
      <template v-slot:footer>
        <span></span>
      </template>
    </v-base-dialog>
  </div>
</template>

<script>
import BreadCrumb from '../components/Breadcrumb'
// import commonTab from '../components/CommonTab/CommonTab'
import fails404 from './fails404'
import vBaseDialog from '@/components/module/baseDialog'
import indexApi from '@/api/workbench'
import storage from '@/util/storage'
import { cloneDeep } from 'loadsh'
import { byLoginUser } from '@/api/system/rightsManagement'
import { getAuth, removeAuth, removeToken, removeCookie } from '../util/auth'
import { encode64, isSuccess } from '@/util/tool' // get token from cookie
import { mapState, mapMutations } from 'vuex'
import { deepClone } from '@/util'

export default {
  name: 'Main',
  data () {
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.updataPsdForm.newpsd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
    var checkpassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('密码不能为空'))
      } else {
        if (value.length < 8) {
          callback(new Error('密码不可小于8位'))
        } else if (value.length > 16) {
          callback(new Error('密码不可大于16位'))
        } else if (!reg.test(value)) {
          callback(new Error('密码至少要包含数字,字符,字母中的两种'))
        } else {
          callback()
        }
      }
    }
    return {
      tableHeight: window.innerHeight - 60,
      // parentLevelPath: '', // 一级菜单
      mainSubNav: false,
      dataMenu: [],
      dataSubMenu: [],
      activeMenu: '1',
      activeMenuLast: '2',
      userName: '',
      loginDialogVisible: false,
      upsdDialogVisible: false,
      actdDialogVisible: false,
      screenWidth: '',
      userInfo: {},
      loading: false,
      accountForm: {},
      updataPsdForm: {},
      updataRules: {
        psd: [
          {
            required: true,
            message: '请输入当前密码',
            trigger: 'blur'
          }
        ],
        newpsd: [
          {
            required: true,
            trigger: 'blur',
            validator: checkpassword
          }
        ],
        againNewpsd: [
          {
            required: true,
            trigger: 'blur',
            validator: validatePass2
          }
        ]
      },
      // screenHeight: '',
      moreList: []
    }
  },
  components: {
    BreadCrumb,
    vBaseDialog,
    fails404
    // commonTab
  },
  computed: {
    ...mapState(['informNum', 'dataSubMeunCurActiveEx', 'tabsList'])
  },
  mounted () {
    this.queryRight()
    this.getUser()
    this.getWidthMenu()
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth
    }
    this.getMsg()
  },
  watch: {
    screenWidth: {
      handler (newVal) {
        this.getWidthMenu()
        return newVal
      },
      keep: false
    },
    $route () {
      this.queryRight() // 初始化
      this.getMsg()
    }
  },
  methods: {
    ...mapMutations(['setDataSubMeunEx', 'updataInfofrom', 'setBacklogActiveName']),
    clearFrom () {
      this.updataPsdForm = Object.assign(this.updataPsdForm, {
        psd: '',
        newpsd: '',
        againNewpsd: ''
      })
    },
    getMsg() {
      indexApi.workIndexNotice().then(res => {
        if (isSuccess(res)) {
          const { obj } = res.data
          this.updataInfofrom({
            notice: obj.noticeCount,
            inform: obj.informCount,
            backlog: obj.backlogCount
          })
        }
      })
    },
    subMeunOpen (index) {
      const { dataSubMenu } = this
      const data = dataSubMenu.find(item => item.powerUrl === index)
      if (data && data.children) {
        this.setDataSubMeunEx(deepClone([data]))
      }
    },
    powerName (item) {
      this.setBacklogActiveName('a')
      // // 调用vuex的selectMenu方法存储数据
      // this.$store.commit('selectMenu', item)
    },
    goIndex () {
      this.$router.push('/workbench/workbenchManage/home')
      this.queryRight()
    },
    // 一级菜单事件
    handleSelect (index, a) {
      this.mainSubNav = false
      this.activeMenu = index
      // const { query } = this.$route
      this.activeMenuLast = this.$route.path.includes(
        '/system/systemSet/processManagement'
      )
        ? '/system/systemSet/processManagement'
        : this.dataSubMeunCurActiveEx ? this.dataSubMeunCurActiveEx : this.$route.path
      this.dataMenu.forEach((item) => {
        if (item.children && item.powerUrl === index) {
          this.dataSubMenu = item.children
          this.setDataSubMeunEx(deepClone(item.children))
          this.$nextTick(() => {
            this.mainSubNav = true
          })
        }
      })
      const url = this.$route.path
      // const arr = url.split('/')
      // const baseurl = `/${arr[1]}/${arr[2]}`
      let objex = false
      // let params = ''
      this.dataSubMenu.forEach((item) => {
        item.children.forEach((itemex) => {
          if (itemex.powerUrl.includes(url)) objex = true // || itemex.powerUrl.includes(baseurl)
          // if (itemex.powerUrl.includes(url)) {
          //   params = itemex
          //   objex = true // || itemex.powerUrl.includes(baseurl)
          // }
        })
      })
      // if (objex) {
      //   this.powerName(params)
      // }
      storage.set('navMenu', this.dataMenu)
      if (objex) return
      if (this.dataSubMenu && this.dataSubMenu[0] && a) {
        const obj = this.dataSubMenu[0]
        if (obj) {
          this.$router.push(obj.children[0].powerUrl)
          this.activeMenuLast = obj.children[0].powerUrl
          // this.powerName(obj.children[0])
        }
      }
    },
    // 根据窗口展示菜单数量
    getWidthMenu () {
      if (this.screenWidth < 1368) {
        this.moreList = this.dataMenu.slice(-1)
        if (this.screenWidth < 1230) {
          this.moreList = this.dataMenu.slice(-2)
        }
        if (this.screenWidth < 1120) {
          this.moreList = this.dataMenu.slice(-3)
        }
      }
    },
    // 获取当前用户信息
    getUser () {
      this.userName = JSON.parse(getAuth()).usercnname
    },
    sortKey (array, key) {
      return array.sort(function (a, b) {
        var x = a[key]
        var y = b[key]
        return x < y ? -1 : x > y ? 1 : 0
      })
    },
    // 菜单渲染
    queryRight () {
      byLoginUser()
        .then((res) => {
          if (res.data.code === 200) {
            let arrList = []
            arrList = this.$ConTree(
              res.data.obj,
              'id',
              'powerFather',
              'children'
            )
            arrList.forEach((item) => {
              if (item.children) {
                item.children.forEach((res) => {
                  if (res.children) {
                    res.children = this.sortKey(res.children, 'serial') // 最后一级菜单根据serial排序
                  }
                })
              }
            })
            // 排序后再赋值
            this.dataMenu = arrList
            // 获取窗口宽度大小
            this.screenWidth = document.body.clientWidth
            // this.screenHeight = document.body.clientHeight
            const initial = this.$route.path.split('/')
            let iniIndex = '/' + initial[1]
            if (this.$route.path.includes('/sell/personageManagement/acceptDraftCollections')) {
              iniIndex = '/' + 'finance'
            }
            this.handleSelect(iniIndex, false)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 修改密码
    updataPsd () {
      this.$refs.updataPsdForm.validate((vail) => {
        if (vail) {
          const { newpsd, psd } = this.updataPsdForm
          const { userInfo } = this
          this.loading = true
          indexApi
            .updataPsd({
              id: userInfo.id,
              isSystemUser: userInfo.isSystemUser,
              password: encode64(newpsd),
              opassword: encode64(psd),
              staffName: userInfo.username,
              staffUseName: ''
            })
            .then((res) => {
              this.loading = false
              if (isSuccess(res)) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                this.upsdDialogVisible = false
              } else {
                this.$message.error(res.data.msg)
                return
              }
              this.updataPsdForm.psd = ''
              this.updataPsdForm.newpsd = ''
              this.updataPsdForm.alignNewPsd = ''
            })
        }
      })
    },
    // 账号信息
    getAccountInfo () {
      const { id } = this.userInfo
      indexApi
        .getAccountInfo({
          id
        })
        .then((res) => {
          if (isSuccess(res)) {
            let orgName = ''
            let roleName = ''
            this.actdDialogVisible = true
            this.accountForm = cloneDeep(res.data.obj)
            this.accountForm.comOrganizations &&
              this.accountForm.comOrganizations.forEach((item) => {
                orgName += item.orgName + ','
              })
            this.accountForm.systemRoleList &&
              this.accountForm.systemRoleList.forEach((item) => {
                roleName += item.roleName + ','
              })
            Object.assign(this.accountForm, {
              orgName: orgName.substring(0, orgName.length - 1),
              roleName: roleName.substring(0, roleName.length - 1),
              password: '---------'
            })
          }
        })
    },
    loginOut () {
      // 退出
      this.$router.push('/login')
      removeToken()
      removeCookie()
      removeAuth()
    },
    handleCommand (command) {
      try {
        this.userInfo = JSON.parse(getAuth())
      } catch (e) {
        this.userInfo = {}
      }
      if (command === 'logOut') {
        this.loginDialogVisible = true
      } else if (command === 'updataPsd') {
        this.upsdDialogVisible = true
      } else {
        this.getAccountInfo()
      }
    },
    handleinforomCommand (command) {
      if (command) {
        this.$router.push({
          name: command
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .main {
    width: 100%;
    height: 100%;

    .el-header {
      padding: 0;
      display: flex;
      font-size: 16px !important;
      justify-content: space-between;

      .main-logout {
        display: flex;

        .main-news {
          height: 100%;
          line-height: 20px;
          margin-top: 20px;
          position: relative;
          padding-right: 20px;

          i {
            padding-right: 13px;
          }
        }

        .main-user {
          line-height: 60px;
        }
      }

      .head-portrait {
        margin: auto;
        margin-right: 12px;
        width: 36px;
        height: 36px;
      }
    }

    .main-nav {
      .el-menu {
        border: none;

        .el-menu-item {
          font-size: 16px;
          border: none;
        }

        .el-menu-item.is-active {
          border: none;
          color: #409eff;
          background: #f5f7fa;
        }
      }

      #more-menu {
        .el-menu--horizontal .el-submenu__title:not(.is-disabled):focus,
        .el-menu--horizontal .el-submenu__title:not(.is-disabled):hover,
        .el-menu--horizontal .el-submenu__title:not(.is-disabled):focus i,
        .el-menu--horizontal .el-submenu__title:not(.is-disabled):hover i {
          color: rgb(78, 85, 91) !important;
          background-color: #fff;
        }

        .el-submenu__title i,
        span {
          color: rgb(78, 85, 91) !important;
          font-size: 16px;
        }

        .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
          border-bottom: none;
        }

        .el-submenu i {
          color: rgb(78, 85, 91);
        }

        .el-submenu__title:hover {
          background-color: #fff !important;
        }

        .el-submenu:visited,
        .el-submenu:focus,
        .el-submenu:hover,
        .el-submenu.is-active .el-submenu:visited i,
        .el-submenu:focus i,
        .el-submenu:hover i,
        .el-submenu.is-active {
          background-color: #fff;
          color: rgb(78, 85, 91) !important;
        }
      }
    }

    .inform_icon .el-badge__content.is-fixed {
      right: 20px;
      height: 16px;
      line-height: 16px;
      padding: 0 5px;
    }

    .el-main {
      position: relative;
    }
  }
</style>
